<template>
  <div>
    <div class="mb-1 d-flex align-baseline">
      <div class="subtitle2 mr-1">{{ $t("ticketDetails.users") }}:</div>
      <div>
        <div data-testid="ticket-preview-users" class="body2">
          {{ ticketDetails.sections.triggeredUser }}
        </div>
      </div>
    </div>

    <users-protection-alert
      v-if="showAddToProtectionBtn"
      class="mb-1"
      :ticket-details="ticketDetails"
      :add-users-not-allowed="addUsersNotAllowed"
      @on-users-add-clicked="addUsers(usersToAdd)"
    />

    <div class="mb-1">
      <span v-if="ticketDetails.eventType === TicketType.USER_INACTIVITY" class="subtitle2">
        {{ $t("ticketDetails.inactiveSince") }}:
      </span>
      <span v-else class="subtitle2">{{ $t("ticketDetails.from") }}: </span>
      <span class="body2" data-testid="ticket-preview-starttime">{{
        getFormattedDateTime(ticketDetails.startTime)
      }}</span>
    </div>

    <div
      class="mb-1"
      v-if="ticketDetails.endTime && ticketDetails.eventType !== TicketType.USER_INACTIVITY"
    >
      <span class="subtitle2">{{ $t("ticketDetails.to") }}: </span>
      <span class="body2" data-testid="ticket-preview-endtime">
        {{ getFormattedDateTime(ticketDetails.endTime) }}
      </span>
    </div>

    <div class="d-flex align-center mb-1">
      <div class="subtitle2">{{ $t("general.service") }}:</div>
      <div class="d-flex align-center">
        <v-icon
          v-if="ticketDetails.sections.serviceName === Service.OUTBOUND_PROXY"
          size="25"
          class="mr-2"
          icon="$outboundGateway"
        />
        <coro-icon v-else class="service-icon" :icon-name="ticketDetails.sections.serviceName" />
        <span
          class="body2"
          :data-testid="`ticket-preview-service-${ticketDetails.sections.serviceName}`"
        >
          {{ $t(`services.${ticketDetails.sections.serviceName}`) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TicketDetails } from "@/_store/tickets/tickets.module";
import CoroIcon from "@/components/CoroIcon.vue";
import UsersProtectionAlert from "@/components/tickets/ticket-preview-details/UsersProtectionAlert.vue";
import { useTicketPreviewGeneralInfo } from "@/composables/useTicketPreviewGeneralInfo";
import { TicketType } from "@/constants/tickets";

const props = defineProps<{
  ticketDetails: TicketDetails;
}>();

const {
  getFormattedDateTime,
  addUsersNotAllowed,
  usersToAdd,
  showAddToProtectionBtn,
  addUsers,
  Service,
} = useTicketPreviewGeneralInfo(props.ticketDetails);
</script>

<style lang="scss" scoped>
.service-icon {
  width: 25px;
  height: 25px;
}
</style>
